import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  loadWhisperCore: false,
  type: 'application',
  auth: 'none',
  additionalDlbs: ['apollo-dlb/bundle.js'],
  logFetchErrors: {
    options: {
      ignoreErrors: []
    }
  },
  htmlTitle: 'Billing Portal',
  htmlTitleLangKey: 'app.htmlTitle',
  historyBasename: '/:basename',
  includeDefaultViewportMetaTag: true,
  createRootApi: true
});